var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStripe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    viewBox: "0 149.4 512 213.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6772E5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st0",
    d: "M36.05,233.02c0-5.61,4.49-7.72,12.06-7.72c10.8,0,24.41,3.23,35.21,9.12v-33.39   c-11.78-4.63-23.43-6.59-35.21-6.59C19.22,194.44,0,209.45,0,234.7c0,39.28,54.01,32.96,54.01,49.94c0,6.59-5.75,8.7-13.61,8.7   c-11.78,0-26.93-4.77-38.86-11.36v33.81c13.19,5.75,26.65,8.14,38.86,8.14c29.6,0,49.94-14.59,49.94-40.12   C90.2,241.43,36.05,248.87,36.05,233.02z M132.14,165.96l-34.65,7.43l-0.14,113.9c0,21.04,15.85,36.61,36.89,36.61   c11.64,0,20.2-2.1,24.83-4.63v-28.9c-4.49,1.82-27.07,8.42-27.07-12.62v-50.5h27.07v-30.3H132L132.14,165.96z M203.26,207.35   l-2.24-10.52h-30.72v124.42h35.49v-84.3c8.42-10.94,22.58-8.98,27.07-7.43v-32.68C228.23,195.14,211.67,192.06,203.26,207.35z    M241.55,196.82h35.63v124.42h-35.63L241.55,196.82L241.55,196.82z M241.55,186.02l35.63-7.72v-28.9l-35.63,7.57L241.55,186.02   L241.55,186.02z M351.39,194.44c-13.89,0-22.86,6.59-27.91,11.08l-1.82-8.84h-31.28v165.8l35.49-7.57l0.14-40.26   c5.19,3.65,12.62,8.98,25.11,8.98c25.39,0,48.68-20.48,48.68-65.51C399.78,216.88,376.36,194.44,351.39,194.44z M342.83,292.49   c-8.42,0-13.33-2.95-16.83-6.73l-0.14-52.74c3.65-4.07,8.84-7.01,16.97-7.01c12.91,0,21.88,14.45,21.88,33.1   C364.85,278.18,356.02,292.49,342.83,292.49z M512,259.53c0-36.47-17.67-65.09-51.34-65.09c-33.81,0-54.29,28.76-54.29,64.81   c0,42.78,24.13,64.39,58.92,64.39c16.97,0,29.74-3.79,39.42-9.26V285.9c-9.68,4.77-20.76,7.86-34.79,7.86   c-13.75,0-26.09-4.77-27.63-21.6h69.58C511.72,270.33,512,263.03,512,259.53z M441.72,246.06c0-16.13,9.82-22.72,18.8-22.72   c8.7,0,17.96,6.73,17.96,22.72H441.72z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/stripe.ab28b356e7993073fe3cfcdca2c91a48.svg";
export { ForwardRef as ReactComponent };